<!-- <template> -->
    <transition name="el-zoom-in-center">
      <el-dialog>
            <!-- Content Header (Page header) -->
            <!-- Main content -->
            <section class="content">
                <!-- Default box -->
                <div class="">
                    <el-header>
                    <div class="box-header">
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="remove" data-toggle="tooltip" title="Remove" class="btn btn-box-tool"><i class="ti-close"></i></button>
                        </div>
                    </div>
                    </el-header>
                    <el-main>
                           <el-row :gutter="20">
                                 <el-col :span="8" :offset="9">   
                                 
                                   <p class = "headingName"><i class="el-icon-arrow-down"></i>&nbsp;Add Publisher to Automatad</p>
                               </el-col>
                        </el-row>
                    <div class="">
                            <el-row :gutter="20">
                              <el-col :span="4" :offset="6"><p class = "paragraphBold">Name</p></el-col>

                              <el-col :span="6"><el-input placeholder="Please input" v-model="input"></el-input></el-col>
                            </el-row>
                            <el-row :gutter="20">
                             <el-col :span="4" :offset="6"><p class = "paragraphBold">Add Publisher</p></el-col>
                              <el-col :span="8"><el-input placeholder="Please input" v-model="input"></el-input></el-col>
                            </el-row>
                            <el-row :gutter="20">
                             <el-col :span="4" :offset="6"><p class = "paragraphBold">Sample Text</p></el-col>
                              <el-col :span="8"><el-input placeholder="Please input" v-model="input"></el-input></el-col>
                            </el-row>
                            <el-row :gutter="20">
                             <el-col :span="4" :offset="6"><p class = "paragraphBold">Sample Text</p></el-col>
                              <el-col :span="8"><el-input placeholder="Please input" v-model="input"></el-input></el-col>
                            </el-row>
                            <el-row :gutter="20">
                             <el-col :span="4" :offset="6"><p class = "paragraphBold">Sample Text</p></el-col>
                              <el-col :span="8"><el-input placeholder="Please input" v-model="input"></el-input></el-col>
                            </el-row>
                    </div>
                       <el-col :span="8" :offset="16">   
                        <el-button class = "successButton" type="success" icon="el-icon-check">Add Publisher</el-button>

                       </el-col>

                </el-main>
                    <!-- /.box-body -->
                </div>
                <!-- /.box -->
                <!-- Default box -->
            </section>
          </el-dialog>
            <!-- /.content -->
    </transition>
<!-- </template> -->
<script>
  export default {
    name: 'FormInput',
    data () {
      return {
        input: '',
        num1: 1
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Demo.vue?7d952d8e